<!--
@component
BodyText component displays story copy.
@prop {string} text - A block of text.

## ArchieML structure
\# Block

Type: BodyText
data: description of video

Pass each prop to the component, for example:
```
{#if block.type === "BodyText"}
	<BodyText text={block.text} />
{/if}
```
-->
<script lang="ts">
	import Block from '../Block/Block.svelte';
	import { marked } from 'marked';

	// PROPS
	export let text: string;
	export let variant: string;

	// LOGIC
</script>

<Block width="narrow">
	<div class="BodyText {variant}">
		{#if text}
			<!-- eslint-disable-next-line svelte/no-at-html-tags -->
			{@html marked.parse(text)}
		{/if}
	</div>
</Block>

<style lang="scss">
	@use '$styles/mq' as *;
	@use '$styles/colors' as *;

	:global(#block-september-13) {
		margin-bottom: 0;
		padding-bottom: 0;
	}

	.BodyText {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		padding-top: var(--theme-section-spacing);
		padding-bottom: var(--theme-section-spacing);
		min-height: 60vh;

		&.first {
			padding-bottom: 0;
			min-height: initial;
		}

		&.last {
			padding-top: 0;
			min-height: initial;
		}
	}

	:global(.BodyText a) {
		color: var(--theme-primary);
		text-decoration: none;

		&:hover {
			text-decoration: underline;
		}
	}

	:global(.BodyText h2) {
		margin: 2rem auto 1rem auto;
		color: var(--theme-primary);
		font-size: 1.3rem;
		line-height: 1.5;
		font-family: var(--brand-font-copy);
	}

	:global(.BodyText h3) {
		margin: 2rem auto 1rem auto;
		color: var(--theme-primary);
		font-size: 1.1rem;
		line-height: 1.5;
		font-family: var(--brand-font-copy);
	}

	:global(.BodyText p) {
		margin: 0 auto 24px auto;
		color: var(--theme-primary);
		font-weight: 200;
		font-size: 18px;
		line-height: 1.8;
		font-family: var(--brand-font-copy);
		letter-spacing: 0.02em;
		word-break: break-word;

		&::selection {
			background-color: var(--theme-primary);
			color: white;
		}
	}
</style>
